/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseImageFragment = gql`
  fragment BaseImageFragment on Image {
    __typename
    sys {
      id
    }
    title
    mobileAsset {
      url
      title
      description
      contentType
    }
    tabletAsset {
      url
      title
      description
      contentType
    }
    desktopAsset {
      url
      title
      description
      contentType
    }
    altText
    url
    openInNewTab
    alignment
    width
    height
    fit
    focus
    format
    quality
    description
  }
`;
